<template>
    <div>
        <div :class="['ui-textbox', 'ui-textbox--icon-position-left', 'is-touched has-label', {'is-disabled': disabled}]">
            <div class="ui-textbox__content">
                <label class="ui-textbox__label">
                    <div class="ui-textbox__label-text">{{ label }}</div> 
                    <masked-input :disabled="disabled" class="ui-textbox__input" v-model="internal" mask="111/11/R11" @input="input" placeholder="000/00/R00" />
                </label>
            </div>
        </div>
    </div>
</template>

<script>
    import MaskedInput from 'vue-masked-input';

    export default {
        components: { 
            MaskedInput 
        },
        props: {
            value: { },
            label: { 
                type: String,
                default: 'Tyre Size',
            },
            disabled: {
                type: Boolean,
                default: false
            }
        },
        created() {
            this.setInternalValue(this.value)
        },
        watch: {
            value(newVal, oldVal) {
                if (oldVal !== newVal && newVal !== this.internal) {
                    this.setInternalValue(newVal)
                }
            }
        },
        data() {
            return {
                internal: '',
            }
        },
        methods: {
            setInternalValue(value) {
                this.internal = value
            },
            input(value) {
                this.$emit('input', value);
            }
        }
    }
</script>